<template>
  <div>
    <b-card>
      <b-row>
        <b-col
          cols="12"
          md="6"
        >
          <slug-text />
        </b-col>
        <b-col
          cols="12"
          md="6"
        >
          <title-text />
        </b-col>
        <b-col
          cols="12"
        >
          <content-text />
        </b-col>
      </b-row>
    </b-card>
    <gif-card />
    <b-button
      variant="primary"
      :disabled="itemData.submitStatus"
      @click="submitForm"
    >
      Kaydet
    </b-button>
  </div>
</template>

<script>
import {
  BCard, BCol, BFormGroup, BFormInput, BRow, BButton,
} from 'bootstrap-vue'

import { ValidationProvider } from 'vee-validate'
import { required } from '@validations'
import vSelect from 'vue-select'
import TitleText from '@/views/Admin/Sectors/elements/Title.vue'
import SlugText from '@/views/Admin/Sectors/elements/Slug.vue'
import ContentText from '@/views/Admin/Sectors/elements/Content.vue'
import ImageCard from '@/views/Admin/Sectors/elements/Image.vue'
import GifCard from '@/views/Admin/Sectors/elements/Gif.vue'

const tableName = 'sectors'
export default {

  name: 'ItemForm',
  components: {
    ImageCard,
    vSelect,
    ValidationProvider,
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    TitleText,
    ContentText,
    GifCard,
    SlugText,
  },
  props: {
    submitForm: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      required,
    }
  },

  computed: {
    itemData() {
      return this.$store.getters['sectors/dataItem']
    },

  },

}
</script>
